import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  return (
    <section className="py-14 md:py-16 bg-background-50" id="categories">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs uppercase tracking-[0.2em] text-foreground-500 font-medium mb-3">Browse by Category</p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            Find Exactly What You Need
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Select a category below to explore verified product listings on our main website
          </p>
        </div>

        <div className="relative max-w-md mx-auto">
          <select
            onChange={(e) => {
              if (e.target.value) window.open(e.target.value, '_blank', 'noopener,nofollow');
            }}
            className="w-full appearance-none bg-background-100 border border-background-300/60 rounded-lg px-5 py-3.5 text-foreground-800 text-sm font-medium cursor-pointer focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all pr-12"
            defaultValue=""
          >
            <option value="" disabled>— Select a Category —</option>
            {categories.map((cat) => (
              <option key={cat.name} value={cat.url}>
                {cat.name}
              </option>
            ))}
          </select>
          <i className="ri-arrow-down-s-line absolute right-4 top-1/2 -translate-y-1/2 text-foreground-500 pointer-events-none text-lg"></i>
        </div>
      </div>
    </section>
  );
}